import { createSlice } from "@reduxjs/toolkit";
import { coerceRouteStoreValue } from "@/routes/nav-route-persistence";

const routeHistorySlice = createSlice({
  name: "routeHistory",
  initialState: {
    routes: {},
    skipNextSave: {},
  },
  reducers: {
    setLastVisitedRoute: (state, action) => {
      const routeKey =
        action.payload.routeKey ?? action.payload.sectionKey;
      const rawPath = action.payload.path;
      if (state.skipNextSave[routeKey]) {
        delete state.skipNextSave[routeKey];
        return;
      }
      if (!routeKey || !rawPath) return;
      state.routes[routeKey] = rawPath;
    },
    clearLastVisitedRoute: (state, action) => {
      const routeKey =
        action.payload.routeKey ?? action.payload.sectionKey;
      if (routeKey) {
        delete state.routes[routeKey];
        state.skipNextSave[routeKey] = true;
      }
    },
  },
});

export const { setLastVisitedRoute, clearLastVisitedRoute } =
  routeHistorySlice.actions;

/** Last visited path for this CRM nav leaf (pathname and query when present). */
export const selectLastVisitedRoute = (routeKey) => (state) => {
  const v = state.routeHistory?.routes?.[routeKey];
  return coerceRouteStoreValue(v);
};

export default routeHistorySlice.reducer;
